import { VApp } from 'vuetify/lib/components/VApp';
import { VImg } from 'vuetify/lib/components/VImg';
import { VMain } from 'vuetify/lib/components/VMain';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VApp,{staticClass:"content"},[_c(VMain,[_c('div',{staticClass:"d-md-flex"},[_c('a',{attrs:{"href":"https://www.brani.cz","target":"_blank"}},[_c(VImg,{staticClass:"shrink",attrs:{"alt":"Logo","contain":"","src":"/brani-logo-white-center.png","height":"64"}})],1),_c(VSpacer)],1),_c('router-view'),_c('div',{staticClass:"circle"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }